import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { HomeComponent } from './features/home/home.component';
import { ProfileComponent } from './features/profile/profile.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { LotteryResultsComponent } from './shared/lottery-results/lottery-results.component';
import { ContactUsComponent } from './features/contact-us/contact-us.component';
import { LoginModalComponent } from './modals/login-modal/login-modal.component';
import { RegisterModalComponent } from './modals/register-modal/register-modal.component';
import { ForgotPasswordModalComponent } from './modals/forgot-password-modal/forgot-password-modal.component';
import { CountdownComponent } from './shared/countdown/countdown.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RulesComponent } from './pages/rules/rules.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgxStripeModule } from 'ngx-stripe';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastPopupComponent } from './shared/toast-popup/toast-popup.component';
import { CompleteForgotPasswordComponent } from './features/complete-forgot-password/complete-forgot-password.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UnauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';
import { AccountActivatedComponent } from './pages/account-activated/account-activated.component';
import { EmailChangedComponent } from './pages/email-changed/email-changed.component';
import { WizardComponent } from './features/wizard/wizard.component';
import { SelectTicketComponent } from './features/wizard/select-ticket/select-ticket.component';
import { VoteTicketComponent } from './features/wizard/vote-ticket/vote-ticket.component';
import { CheckoutComponent } from './features/wizard/checkout/checkout.component';
import { PurchaseConfirmedComponent } from './pages/purchase-confirmed/purchase-confirmed.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { environment } from 'src/environments/environment';
import { SeedModule } from './features/seed/seed.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    CookiePolicyComponent,
    PrivacyPolicyComponent,
    HomeComponent,
    ProfileComponent,
    TermsAndConditionsComponent,
    LoaderComponent,
    LotteryResultsComponent,
    ContactUsComponent,
    LoginModalComponent,
    RegisterModalComponent,
    ForgotPasswordModalComponent,
    CountdownComponent,
    RulesComponent,
    ToastPopupComponent,
    CompleteForgotPasswordComponent,
    AccountActivatedComponent,
    EmailChangedComponent,
    WizardComponent,
    SelectTicketComponent,
    VoteTicketComponent,
    CheckoutComponent,
    PurchaseConfirmedComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    NgxStripeModule.forRoot(environment.STRIPE_KEY),
    HttpClientModule,
    ReactiveFormsModule,
    SeedModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: UnauthorizedInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent],
})
export class AppModule { }
